import MinimumCqlScoreWidget from './../MinimumCqlScoreWidget'
import MarketoProgramSelect from './MarketoProgramSelect'
import { withProps } from 'recompose'
import {
  setMinimumCqlScore,
  getMinimumCqlScore,
  getMarketoLeadOwnerField,
  setMarketoLeadOwnerField,
  queryMarketoPrograms,
  fetchMarketoPrograms,
  getDefaultMarketoProgram,
  setDefaultMarketoProgram,
  deleteDefaultMarketoProgram
} from 'app/modules/integrations/api'
import { api } from 'app/modules/marketo/api'
import MarketoMappedLeadOwnerInput from './MarketoMappedLeadOwnerInput'

export const model = [
  {
    type: 'syncLeadsEnabled',
    value: false,
    label: 'Sync leads from Drift to Marketo',
    description: `Leads from Drift will be created or updated in Marketo whenever a conversation closes`,
    openAdvancedSettingsOnEnable: true,
    children: {
      label: 'Associate leads with a Marketo Program',
      description: 'Drift will add the lead to a program.',
      topLevelAdvancedItems: [],
      advancedComponent: withProps({
        fetchPrograms: fetchMarketoPrograms,
        queryPrograms: queryMarketoPrograms,
        getSelectedProgram: getDefaultMarketoProgram,
        setProgram: setDefaultMarketoProgram,
        deleteProgram: deleteDefaultMarketoProgram
      })(MarketoProgramSelect),
      items: []
    }
  },
  {
    type: 'identityResolutionEnabled',
    value: false,
    label: 'Identify Drift visitors with the Marketo cookie',
    description: `If someone was already identified by Marketo, Drift will automatically recognize them as a known contact. We'll only check Marketo if the visitor has a Marketo cookie set.`,
  },
  {
    type: 'associateLeadsEnabled',
    value: false,
    label: 'Attach anonymous history to Marketo leads',
    description: 'Use Marketo’s Munchkin Cookies to attach browsing history to an anonymous Marketo lead when they become identified in Drift'
  },
  {
    type: 'conversationTranscriptEnabled',
    value: false,
    label: 'Include Conversation Transcripts on Activities pushed to Marketo',
    description: `If the 'New Drift Conversation' activity is mapped below, we'll added a raw conversation transcript as an attribute on the activity`
  },
  {
    type: 'shouldOnlySyncQualifiedLeads',
    value: false,
    label: 'Set a minimum CQL score for synced contacts and conversations',
    description: 'Unchecked, Drift will sync all contacts and conversations to Marketo.',
    topLevelAdvancedItems: [],
    children: {
      autoExpand: true,
      label: 'Minimum CQL score',
      description: 'Drift will only sync conversations that have the selected CQL score or higher.',
      topLevelAdvancedItems: [],
      advancedComponent: withProps({ integrationName: 'marketo',
        setMinimumCQLScore: (data) => setMinimumCqlScore(data),
        getMinimumCQLScore: (data) => getMinimumCqlScore(data)
      })(MinimumCqlScoreWidget),
      items: []
    }
  },
  {
    type: 'leadOwnerFieldEnabled',
    value: false,
    label: 'Assign a Lead Owner in Marketo',
    description: "For every new contact that Drift creates, we'll assign a Lead Owner email based on who books a meeting, who was routed into the conversation, or who closes the conversation (in that order!).",
    openAdvancedSettingsOnEnable: true,
    children: {
      label: 'Lead Owner field',
      description: "Which Marketo field should Drift use? Note that this will overwrite the chosen field’s existing value in Marketo.",
      topLevelAdvancedItems: [],
      advancedComponent: withProps({
        getMarketoLeadOwnerField,
        setMarketoLeadOwnerField,
        fetchMarketoFields: api.fetchMarketoFields,
      })(MarketoMappedLeadOwnerInput),
      items: []
    }
  },
]

export const hydrateModel = toggles => {
  return [...model].map(topLevel => {
    const updatedToggle = Object.assign({}, topLevel)
    updatedToggle.value = toggles[topLevel.type]
    return updatedToggle
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/MarketoConfig/model.js